// Achievement catalogue (v1 — generic, low-touch situations only; nothing about employee performance,
// nothing that needs page-specific instrumentation). Each describes a situation, never a person.
export interface AchievementDef {
    id: string;
    emoji: string;
    title: string;
    desc: string;
}

export const ACHIEVEMENTS: AchievementDef[] = [
    { id: 'early-bird', emoji: '🌅', title: 'The Early Bird', desc: 'Used the Backoffice before 07:00.' },
    { id: 'night-watch', emoji: '🌙', title: 'The Night Watch', desc: 'The Backoffice has seen you at an unreasonable hour.' },
    { id: 'still-there', emoji: '⏳', title: 'Are You Still There?', desc: 'A Backoffice session of questionable duration.' },
    { id: 'deja-vu', emoji: '🔁', title: 'Déjà Vu', desc: "We've definitely been here before." },
    { id: 'i-am-speed', emoji: '⚡', title: 'I Am Speed', desc: "Navigated at a pace the API wasn't emotionally prepared for." },
    { id: 'clever-girl', emoji: '🦖', title: 'Clever Girl…', desc: 'Found one of the Easter eggs.' },
    { id: 'curious-one', emoji: '🔍', title: 'Curious One', desc: 'You came looking for achievements.' },
    { id: 'mere-mortal', emoji: '🛡️', title: 'Mere Mortal', desc: 'Survived the expiration of God Mode.' },
    { id: 'ice-and-fire', emoji: '🧊', title: 'A Song of Ice and Fire', desc: 'Winter came. You brought fire. Still has emails to answer.' },
];
